import { Pipe, PipeTransform } from '@angular/core';

/*
 * Format a name to have the proper possessive ending
 *
 * Usage:
 *   value | possessive
 * Example:
 *   {{ Charles |  possessive}}
 *   formats to: Charles'
 */

@Pipe({
    name: 'possessive',
    standalone: true
})
export class PossessivePipe implements PipeTransform {
	transform(value: string): string {
		if (value) {
			const newValue = value.trim();
			if (newValue.charAt(newValue.length - 1).toLowerCase() === 's') {
				return newValue + "'";
			} else {
				return newValue + "'s";
			}
		}
		return value;
	}
}
